import { config } from "../../../config";
import { uuidv4 } from "../../../utils/uuid";
import yup, { yupUUID } from "../../../utils/yup";

const chatButtonSchema = yup.object({
  id: yupUUID.default(() => uuidv4()),
  chat_moment_id: yupUUID,
  text: yup
    .string()
    .required("Enter some text for the button")
    .default("")
    .max(config.slack.maxBlockLength, "Button text too long."),
  link: yup
    .string()
    .url_or_merge_tag("Enter a link in a valid format (including https://)")
    .required("Enter a link for the button")
    .default(""),
});

export const chatMomentSchemaShape = {
  id: yupUUID.default(() => uuidv4()),
  slack_alias_id: yupUUID.nullable().default(null),
  title: yup.string().default("").max(config.slack.maxBlockLength, "Title too long."),
  design: yup.object({}).optional(),
  image_url: yup.string().nullable().defined(),
  buttons: yup.array(chatButtonSchema).default([]),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const chatMomentSchema = yup.object(chatMomentSchemaShape);
export type ChatMoment = yup.InferType<typeof chatMomentSchema>;
